import {Component, inject} from '@angular/core';
import {ButtonComponent} from "../../../components/buttons/button/button.component";
import {FormsModule} from "@angular/forms";
import {InputComponent, ToastService} from "@components";
import {ProfileIconComponent} from "@icons";
import {RouterLink} from "@angular/router";
import {TranslocoPipe} from "@jsverse/transloco";
import {AuthService} from "@api-services";
import {watchParam} from "@utils";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";

@Component({
  selector: 'wun-password-reset',
  imports: [
    ButtonComponent,
    FormsModule,
    InputComponent,
    ProfileIconComponent,
    RouterLink,
    TranslocoPipe
  ],
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.scss'
})
export class PasswordResetComponent {

  private readonly authService = inject(AuthService)
  public readonly token = watchParam('token');
  private readonly toastService = inject(ToastService);

  passwordReset(value: string) {
    this.authService.authsSendRecoveryLink({
      recoveryPasswordRequestDto: {
        email: value
      }
    }).subscribe(f => {
      this.toastService.addMessage({
        title: 'passwordRecovery.sent',
        severity: 'success',
      })
    })
  }

  recoveryPassword(value: string, value2: any) {
    if(value !== value2) {
      this.toastService.addMessage({
        severity: 'error',
        title: 'signup.passwordNotMatch',
      })
      return;
    }
    this.authService.authsResetPassword({
      resetPasswordRequest: {
        password: value,
        confirmPassword: value2,
        token: this.token()!
      }
    }).pipe(catchError(err => {
      this.toastService.addMessage({
        severity: 'error',
        title: 'common.somethingWentWrong',
      })
      return throwError(() => err)
    }))
      .subscribe(() => {
      this.toastService.addMessage({
        severity: 'success',
        title: 'passwordRecovery.passwordChanged',
      })
    })
  }
}
